import type { TrayShare } from "./types";

/**
 * MEASURED, never `routing_mode`.
 *
 * That flag lies: the BMZ ring reports `routing_mode: "tray"` on **3.23 m of
 * 213.59** — 1.5% — and three more circuits sit under 10%. A badge that
 * repeated the flag would tell him a run is "on tray" when it essentially is
 * not, and this indicator exists so he can CHECK the routing rather than be
 * told about it. The flag is deliberately not parsed anywhere in the client.
 */
export const trayShare: TrayShare = ({ onTrayM, routedM }) => {
  if (!onTrayM || onTrayM <= 0) return null;
  if (!routedM || routedM <= 0) return null;
  // Clamped: a run whose tray metres exceed its own routed length is noise in
  // the data, and "143%" on a row is worse than "100%".
  const percent = Math.min(100, Math.round((onTrayM / routedM) * 100));
  return { percent, onTrayM, routedM };
};
